import { render } from "./TemplateView.vue?vue&type=template&id=6512250b"
import script from "./TemplateView.vue?vue&type=script&lang=js"
export * from "./TemplateView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__